var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('switch-roles',{on:{"change":_vm.handleRolesChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }